document.addEventListener(
  "DOMContentLoaded",
  () => {
    const reducedMotionMQ = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    );

    // eslint-disable-next-line no-extra-boolean-cast
    if (
      reducedMotionMQ &&
      !reducedMotionMQ.matches &&
      !window.buplDisableAnimations
    ) {
      document.documentElement.classList.add("has-animations");
      if (window.IntersectionObserver) {
        document.documentElement.classList.add("has-intersect-animations");

        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-in-view");

                // The item has come into view, so we'll stop observing.
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "0px 0px -50px 0px" },
        );
        document.querySelectorAll(".js-in-view-check").forEach((element) => {
          observer.observe(element);
        });
      }
    }
  },
  { once: true },
);
